import {_buildQuery, _buildQueryCustom} from "../helpers/helper";

let ueser_login = async function (param) {
    return window.GETCCMT.$http.post('/login', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let ueser_login_verify = async function (param) {
    return window.GETCCMT.$http.post('/login/verify', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests = async function (param, params_router) {
  if (params_router.stringSearch){
    // let url = _buildQueryCustom(params_router.stringSearch)
    let url = '&search='+params_router.stringSearch;
    return window.GETCCMT.$http.get('/requests?page='+params_router.page+''+url+'&type=' + params_router.type).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }else {
    return window.GETCCMT.$http.get('/requests' + _buildQuery(params_router)).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }
};

let findRequests = async function (param) {
  return window.GETCCMT.$http.get('/requests/find-requests' + _buildQuery(param)).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
  });
};

let requestsMe = async function (param, params_router) {
    if (params_router.stringSearch){
      let url = _buildQueryCustom(params_router.stringSearch)
      return window.GETCCMT.$http.get('/requests/me?page='+params_router.page+''+url).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
      });
    }else {
      return window.GETCCMT.$http.get('/requests/me?page=' + params_router.page, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
      });
    }
  };

let sub_categories_requests = async function (param, id) {
    return window.GETCCMT.$http.get('/sub-requests/get/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let customers = async function (param) {
    return window.GETCCMT.$http.get('/customers', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let customers_contracts = async function (param, id) {
    return window.GETCCMT.$http.get('/customers/contracts/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let priorities = async function (param) {
    return window.GETCCMT.$http.get('/priorities', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_create = async function (param) {
    return window.GETCCMT.$http.post('/requests/create', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_detail_information = async function (param, id) {
    return window.GETCCMT.$http.get('/requests/detail/information/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_detail_history = async function (param, id) {
    return window.GETCCMT.$http.get('/requests/detail/history/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_detail_tasks = async function (param, id) {
    return window.GETCCMT.$http.get('/requests/detail/tasks/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_detail_comments = async function (param) {
    return window.GETCCMT.$http.get('/comments' + _buildQuery(param)).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_canaux = async function () {
    return window.GETCCMT.$http.get('/requests/get-requests-canaux').catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_tasks_create = async function (param) {
    return window.GETCCMT.$http.post('/requests/tasks/create', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_tasks_update = async function (param) {
    return window.GETCCMT.$http.post('/requests/tasks/update', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_tasks_is_completed = async function (param) {
    return window.GETCCMT.$http.post('/requests/tasks/is-completed', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_tasks_delete = async function (param) {
    return window.GETCCMT.$http.post('/requests/tasks/delete', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_tasks_is_important = async function (param) {
    return window.GETCCMT.$http.post('/requests/tasks/is-important', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_detail_approbation = async function (param, id) {
    return window.GETCCMT.$http.get('/requests/detail/approbation/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_approve = async function (param) {
    return window.GETCCMT.$http.post('/requests/approve', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_reject = async function (param) {
    return window.GETCCMT.$http.post('/requests/reject', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_begin_treat = async function (param) {
    return window.GETCCMT.$http.post('/requests/begin-treat', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_in_progress = async function (param, params_router) {

  if (params_router.stringSearch){
    let url = _buildQueryCustom(params_router.stringSearch)
    return window.GETCCMT.$http.get('/requests/in-progress?page='+params_router.page+''+url).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }else {
    return window.GETCCMT.$http.get('/requests/in-progress' + _buildQuery(params_router)).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }
};

let requests_received = async function (param, params_router) {

  if (params_router.stringSearch){
    let url = _buildQueryCustom(params_router.stringSearch)
    return window.GETCCMT.$http.get('/requests/in-progress?page='+params_router.page+''+url).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }else {
    return window.GETCCMT.$http.get('/requests/received' + _buildQuery(params_router)).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }
};

let requests_suspended = async function (param, params_router) {

  if (params_router.stringSearch){
    let url = _buildQueryCustom(params_router.stringSearch)
    return window.GETCCMT.$http.get('/requests/suspended?page='+params_router.page+''+url).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }else {
    return window.GETCCMT.$http.get('/requests/suspended' + _buildQuery(params_router)).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }
};

let requests_canceled = async function (param, params_router) {

  if (params_router.stringSearch){
    let url = _buildQueryCustom(params_router.stringSearch)
    return window.GETCCMT.$http.get('/requests/canceled?page='+params_router.page+''+url).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }else {
    return window.GETCCMT.$http.get('/requests/canceled' + _buildQuery(params_router)).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }
};

let requests_fencing = async function (param, params_router) {
  if (params_router.stringSearch){
    let url = _buildQueryCustom(params_router.stringSearch)
    return window.GETCCMT.$http.get('/requests/fencing?page='+params_router.page+''+url).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }else {
    return window.GETCCMT.$http.get('/requests/fencing' + _buildQuery(params_router)).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }
};

let requests_not_approved = async function (param, params_router) {

  if (params_router.stringSearch){
    let url = _buildQueryCustom(params_router.stringSearch)
    return window.GETCCMT.$http.get('/requests/not-approved?page='+params_router.page+''+url).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }else {
    return window.GETCCMT.$http.get('/requests/not-approved?page=' + params_router.page, param).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }
};

let requests_close = async function (param) {
    return window.GETCCMT.$http.post('/requests/close', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let dashboard_admin_request_stats = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/admin/request-stats', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let dashboard_admin_bills = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/admin/bills', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let dashboard_dispatcher_request = async function (param) {
  return window.GETCCMT.$http.get('/dashboard/dispatcher/request-stats', param).catch((error) => {
    (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
  });
};


let dashboard_manager_request_stats = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/manager/request-stats', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let dashboard_manager_bills = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/manager/bills', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let dashboard_manager_requests_not_assign = async function (param, params_router) {
    return window.GETCCMT.$http.get('/dashboard/manager/requests-not-assign?page=' + params_router.page, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let dashboard_manager_approbation = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/manager/approbation', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let dashboard_manager_average_treatment = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/manager/average-treatment', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let dashboard_manager_top_agent = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/manager/top-agent', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let dashboard_customer_request_stats = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/customer/request-stats', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let dashboard_customer_last_five_request = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/customer/last-five-request', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};


let dashboard_charger_tasks = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/charger/tasks', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let get_dashboard_charger_sla_end_request = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/charger/request-sla-end', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let get_dashboard_charger_stats = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/charger/request-in-progress-stats', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let dashboard_charger_request_not_assign = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/charger/request-not-assign', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let dashboard_charger_activity_log = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/charger/activity-log', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let dashboard_charger_request_stats = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/charger/request-stats', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let dashboard_charger_graph_week = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/charger/graph-week', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let dashboard_charger_graph_of_request = async function (param) {
    return window.GETCCMT.$http.get('/dashboard/charger/graph-of-request', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};


let notifications = async function (param) {
    return window.GETCCMT.$http.get('/notifications', param).catch((error) => {
        if (error.response.status === 401){
            window.GETCCMT.$router.push('/login')
            // window.location.reload()
        }
    });
};
let notifications_read = async function (param) {
    return window.GETCCMT.$http.post('/notifications/read', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_assign = async function (param) {
    return window.GETCCMT.$http.post('/requests/assign', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let requests_reopen = async function (param) {
    return window.GETCCMT.$http.post('/requests/reopen', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};


let segments = async function (param, params_router) {
    return window.GETCCMT.$http.get('/segments?page=' + params_router.page + '&paginate=' + params_router.paginate, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let segments_create = async function (param) {
    return window.GETCCMT.$http.post('/segments/create', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let segments_detail = async function (param, id) {
    return window.GETCCMT.$http.get('/segments/detail/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let segments_update = async function (param) {
    return window.GETCCMT.$http.post('/segments/update', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let segments_delete = async function (param) {
    return window.GETCCMT.$http.post('/segments/delete', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let chains = async function (param, params_router) {
    return window.GETCCMT.$http.get('/chains?page=' + params_router.page, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let chains_create = async function (param) {
    return window.GETCCMT.$http.post('/chains/create', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let chains_detail = async function (param, id) {
    return window.GETCCMT.$http.get('/chains/detail/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let chains_update = async function (param) {
    return window.GETCCMT.$http.post('/chains/update', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let chains_delete = async function (param) {
    return window.GETCCMT.$http.post('/chains/delete', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let categories_requests = async function (param, params_router) {
    return window.GETCCMT.$http.get('/categories-requests?page=' + params_router.page + '&paginate=' + params_router.paginate, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let categories_requests_create = async function (param) {
    return window.GETCCMT.$http.post('/categories-requests/create', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let categories_requests_detail = async function (param, id) {
    return window.GETCCMT.$http.get('/categories-requests/detail/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let categories_requests_update = async function (param) {
    return window.GETCCMT.$http.post('/categories-requests/update', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let categories_requests_delete = async function (param) {
    return window.GETCCMT.$http.post('/categories-requests/delete', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let sub_requests_get = async function (param, id) {
    return window.GETCCMT.$http.get('/sub-requests/get/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let sub_requests = async function (param, params_router) {
    return window.GETCCMT.$http.get('/sub-requests?page=' + params_router.page + '&paginate=' + params_router.paginate, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let sub_requests_create = async function (param) {
    return window.GETCCMT.$http.post('/sub-requests/create', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let sub_requests_detail = async function (param, id) {
    return window.GETCCMT.$http.get('/sub-requests/detail/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let sub_requests_update = async function (param) {
    return window.GETCCMT.$http.post('/sub-requests/update', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let sub_requests_delete = async function (param) {
    return window.GETCCMT.$http.post('/sub-requests/delete', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let users = async function (param, params_router) {
    return window.GETCCMT.$http.get('/users?page=' + params_router.page + '&profile=' + params_router.profile, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let users_information = async function (param) {
    return window.GETCCMT.$http.get('/users/information', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let users_change_avatar = async function (param) {
    return window.GETCCMT.$http.post('/users/change-avatar', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let users_delete_avatar = async function (param) {
    return window.GETCCMT.$http.post('/users/delete-avatar', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let users_update_information = async function (param) {
    return window.GETCCMT.$http.post('/users/update-information', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let users_change_password = async function (param) {
    return window.GETCCMT.$http.post('/users/change-password', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : ''
    });
};

let outlook = async function (param, params_router) {
  if (params_router.stringSearch){
    return window.GETCCMT.$http.get('/outlook'+params_router.stringSearch).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }else {
    return window.GETCCMT.$http.get('/outlook?page=' + params_router.page, param).catch((error) => {
      (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
  }
};
let outlook_detail = async function (param, id) {
    return window.GETCCMT.$http.get('/outlook/detail/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let outlook_qualify_request = async function (param) {
    return window.GETCCMT.$http.post('/outlook/qualify-request', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

let messages_request = async function (param, id) {
    return window.GETCCMT.$http.get('/messages/request/' + id, param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};
let messages_create = async function (param) {
    return window.GETCCMT.$http.post('/messages/create', param).catch((error) => {
        (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
    });
};

// let is_admin = function () {
//     return (window.GETCCMT.$store.state.AppActiveUser.profile_id === 1) ? true : false
// };
// let is_manager = function () {
//     return (window.GETCCMT.$store.state.AppActiveUser.profile_id === 2) ? true : false
// };
// let is_chargerClientele = function () {
//     return (window.GETCCMT.$store.state.AppActiveUser.profile_id === 3) ? true : false
// };
// let is_client = function () {
//     return (window.GETCCMT.$store.state.AppActiveUser.profile_id === 4) ? true : false
// };
// let is_mandataire = function () {
//     return (window.GETCCMT.$store.state.AppActiveUser.profile_id === 5) ? true : false
// };

// let is_dispatcher = function() {
//   return (window.GETCCMT.$store.state.AppActiveUser.profile_id === 6) ? true : false
// }

// let is_commercial = function() {
//     return (window.GETCCMT.$store.state.AppActiveUser.profile_id === 7) ? true : false
//   }

const getUserProfileId = function() {
    return window.GETCCMT &&
           window.GETCCMT.$store &&
           window.GETCCMT.$store.state &&
           window.GETCCMT.$store.state.AppActiveUser &&
           window.GETCCMT.$store.state.AppActiveUser.profile_id;
};

let is_admin = function () {
    const profileId = getUserProfileId();
    return profileId ? [1].includes(profileId) : false;
};

let is_manager = function () {
    const profileId = getUserProfileId();
    return profileId ? [2].includes(profileId) : false;
};

let is_chargerClientele = function () {
    const profileId = getUserProfileId();
    return profileId ? [3,6].includes(profileId) : false;
};

let is_client = function () {
    const profileId = getUserProfileId();
    return profileId ? [4].includes(profileId) : false;
};

let is_mandataire = function () {
    const profileId = getUserProfileId();
    return profileId ? [5].includes(profileId) : false;
};

let is_dispatcher = function() {
    const profileId = getUserProfileId();
    return profileId ? [6,3].includes(profileId) : false;
};

let is_commercial = function() {
    const profileId = getUserProfileId();
    return profileId ? [7].includes(profileId) : false;
};

let getNavMenuItems = async function () {
    let array = [];
    let submenu = [];
    let submenu_1 = [];
    let is_admin = window.GETCCMT.$store.state.is_admin();
    let is_manager = window.GETCCMT.$store.state.is_manager();
    let is_chargerClientele = window.GETCCMT.$store.state.is_chargerClientele();
    let is_client = window.GETCCMT.$store.state.is_client();
    let is_mandataire = window.GETCCMT.$store.state.is_mandataire();

    // /dashboard
    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire) {
        array.push({
            url: "/dashboard",
            name: "Tableau de bord",
            slug: "home",
            icon: "HomeIcon"
        });
    }

    // Demandes
    submenu = [];
    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire) {
        submenu.push({
            url: "/requests",
            name: "Toutes mes demandes",
            slug: "all-requests"
        });
    }

    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire) {
        submenu.push({
            url: "/requests/pending",
            name: "Demandes en cours",
            slug: "pending-requests"
        });
    }

    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire) {
        submenu.push({
            url: "/requests/fencing",
            name: "Demandes Clôturées",
            slug: "fencing-requests"
        });
    }

    if (is_manager || is_chargerClientele) {
        submenu.push({
            url: "/requests/not-approved",
            name: "Demandes à approuver",
            slug: "closed-requests"
        });
    }

    if (is_chargerClientele) {
        submenu.push({
            url: "/requests/mail",
            name: "Demandes par mail",
            slug: "mail-requests"
        });
    }

    if (submenu.length) {
        array.push({
            url: null,
            name: "Demandes",
            icon: "MessageSquareIcon",
            submenu: submenu
        });
    }

    // Facturations
    submenu = [];

    if (is_chargerClientele || is_client || is_mandataire || is_manager) {
        submenu.push({
            url: '/invoices',
            name: "Factures",
            slug: ""
        });
    }

    if (is_chargerClientele || is_client || is_mandataire) {
        submenu.push({
            url: null,
            name: "Règlements",
            slug: ""
        });
    }

    submenu_1 = [];
    if (is_admin || is_manager || is_chargerClientele) {
        submenu_1.push({
            url: '/uploads/invoices',
            name: 'Factures',
            slug: ""
        },{
            url: '/uploads/payments',
            name: 'Réglement',
            slug: ""
        });
    }

    if (is_chargerClientele) {
        submenu_1.push({
            url: '/uploads/payments',
            name: 'Règlements',
            slug: ""
        });
    }

    if (submenu_1.length) {
        submenu.push({
            url: null,
            name: "Uploads",
            submenu: submenu_1
        });
        submenu_1 = [];
    }

    if (submenu.length) {
        array.push({
            url: null,
            name: "Facturations",
            icon: "FileTextIcon",
            submenu: submenu
        });
    }

    // Statistiques
    submenu = [];

    if (is_client) {
        submenu.push({
            url: '',
            name: 'Statistiques clients',
            slug: ""
        });
    }

    if (is_chargerClientele) {
        submenu.push({
            url: '',
            name: 'Statistiques Chargé de clientèle',
            slug: ""
        });
    }

    if (is_manager) {
      /*
        submenu.push({
            url: '/statistics/manager',
            name: 'Statistiques Manager',
            slug: "statistics-manager"
        });

       */
    }

    if (submenu.length) {
        array.push({
            url: null,
            name: 'Statistiques',
            icon: 'ActivityIcon',
            submenu: submenu
        });
    }

    // profile
    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire) {
        array.push({
            url: '/profile',
            name: 'Profil',
            icon: 'UserIcon',
        });
    }

    // Paramètres
    submenu = [];

    if (is_admin) {
        submenu.push({
            url: '/settings/admin',
            name: 'Paramètres Admin',
            slug: ""
        });
    }

    if (is_admin) {
        submenu.push({
            url: '/segments',
            name: 'segments',
            slug: ""
        });
    }

    if (is_admin) {
        submenu.push({
            url: '/approbations',
            name: 'Chaînes d\'approbations',
            slug: ""
        });
    }

    if (is_admin) {
        submenu.push({
            url: '/categories',
            name: 'Type de demandes',
            slug: ""
        });
    }

    if (is_admin) {
        submenu.push({
            url: '/types',
            name: 'Sous types de demandes',
            slug: ""
        });
    }

    if (is_admin) {
        submenu.push({
            url: '/users',
            name: 'Utilisateurs',
            slug: ""
        });
    }

    if (is_client) {
        submenu.push({
            url: '/settings/master',
            name: 'Paramètres Client Master',
            slug: ""
        });
    }

    if (is_manager) {
        submenu.push({
            url: '/settings',
            name: 'Paramètres Manager',
            slug: ""
        });
    }

    if (submenu.length) {
        array.push({
            url: null,
            name: 'Paramètres',
            icon: 'SettingsIcon',
            submenu: submenu
        });
    }

    return array;
};

let navbarSearchAndPinList = async function () {
    let array = await getNavMenuItems();
    window.AppMainVueCCMT.navMenuItems = array;

    let returnArray = [];

    var length = array.length;
    for (let iuoy = 0; iuoy < length; iuoy++) {
        var item = array[iuoy];

        var title = '';
        var url = '';

        if (item.submenu && item.submenu.length) {
            let submenu_length = item.submenu.length;
            for (let yuhrri = 0; yuhrri < submenu_length; yuhrri++) {
                let item_1 = item.submenu[yuhrri];
                title = item_1.name;
                url = item_1.url;

                returnArray.push({
                    title: title,
                    url: url,
                    icon: item.icon,
                    is_bookmarked: false
                });
            }
        } else {
            title = item.name;
            url = item.url;

            returnArray.push({
                title: title,
                url: url,
                icon: item.icon,
                is_bookmarked: false
            });
        }
    }

    window.AppSearchBarVueCCMT.navbarSearchAndPinList = {
        pages: {
            key: "title",
            data: returnArray
        }
    };
};
/* ----mandataire----
phone: 91350606
Mot de passe: password
----Chargé clientelle----
phone: 96521711
Mot de passe: password
profile_id */

let convertDateTime = function (dateTimeSysteme) {
    let date = dateTimeSysteme.getFullYear() + '-' + ('0' + (dateTimeSysteme.getMonth() + 1)).slice(-2) + '-' + ('0' + dateTimeSysteme.getDate()).slice(-2);
    let time = ('0' + dateTimeSysteme.getHours()).slice(-2) + ':' + ('0' + dateTimeSysteme.getMinutes()).slice(-2) + ':' + ('0' + dateTimeSysteme.getSeconds()).slice(-2);
    let dateTime = date + ' ' + time;

    return {dateTime, date, time};
};


export default {
    messages_request,
    messages_create,
    outlook,
    outlook_detail,
    outlook_qualify_request,
    convertDateTime,
    users_information,
    users_change_avatar,
    users_delete_avatar,
    users_update_information,
    users_change_password,
    users,
    segments,
    segments_create,
    segments_detail,
    segments_update,
    segments_delete,
    chains,
    chains_create,
    chains_detail,
    chains_update,
    chains_delete,
    categories_requests_create,
    categories_requests_detail,
    categories_requests_update,
    categories_requests_delete,
    sub_requests_get,
    sub_requests,
    sub_requests_create,
    sub_requests_detail,
    sub_requests_update,
    sub_requests_delete,
    navbarSearchAndPinList,
    getNavMenuItems,
    requests_reopen,
    requests_assign,
    dashboard_charger_tasks,
    dashboard_charger_request_not_assign,
    get_dashboard_charger_sla_end_request,
    get_dashboard_charger_stats,
    dashboard_charger_activity_log,
    dashboard_charger_request_stats,
    dashboard_charger_graph_week,
    dashboard_charger_graph_of_request,
    notifications,
    notifications_read,
    dashboard_customer_last_five_request,
    dashboard_customer_request_stats,
    dashboard_manager_top_agent,
    dashboard_manager_average_treatment,
    dashboard_manager_approbation,
    dashboard_manager_requests_not_assign,
    dashboard_manager_bills,
    dashboard_manager_request_stats,
    dashboard_admin_bills,
    dashboard_admin_request_stats,
    requests_close,
    requests_not_approved,
    requests_fencing,
    requests_in_progress,
    requests_received,
    requests_suspended,
    requests_canceled,
    requests_begin_treat,
    requests_approve,
    requests_reject,
    requests_detail_approbation,
    requests_tasks_is_important,
    requests_tasks_delete,
    requests_tasks_is_completed,
    requests_tasks_update,
    requests_tasks_create,
    requests_detail_information,
    requests_detail_history,
    requests_detail_tasks,
    requests_detail_comments,
    requests_create,
    requestsMe,
    customers,
    customers_contracts,
    priorities,
    categories_requests,
    sub_categories_requests,
    requests,
    is_admin,
    is_manager,
    is_chargerClientele,
    is_client,
    is_mandataire,
    is_dispatcher,
    ueser_login,
    ueser_login_verify,
    dashboard_dispatcher_request,
    is_commercial,
    findRequests,
    requests_canaux
};
